module.exports = __webpack_public_path__ + "static/img/solenthaler.3517485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/solenthaler.png
// module id = 504
// module chunks = 1